export const setAuthenticationIntent = (path, validSeconds) => {
  sessionStorage.setItem(
    'aIntent',
    JSON.stringify({
      p: path,
      expires: new Date().getTime() + validSeconds * 1000
    })
  );
};

export const clearAuthenticationIntent = () => {
  sessionStorage.removeItem('aIntent');
};

export const getAuthenticationIntentPath = () => {
  const intent = sessionStorage.getItem('aIntent');

  if (!intent) {
    return null;
  }
  clearAuthenticationIntent();
  try {
    const parsedIntent = JSON.parse(intent);

    if (new Date().getTime() < parsedIntent.expires) {
      return parsedIntent.p;
    }
  } catch (e) {
    console.warn('Could not parse authentication intent.');
  }
  return null;
};

// check if there is an authentication intent without clearing it
export const peekAuthenticationIntentPath = () => {
  const intent = sessionStorage.getItem('aIntent');

  if (!intent) {
    return null;
  }
  // Don't clear the intent, just peek at it
  try {
    const parsedIntent = JSON.parse(intent);

    if (new Date().getTime() < parsedIntent.expires) {
      return parsedIntent.p;
    }
  } catch (e) {
    console.warn('Could not parse authentication intent.');
  }
  return null;
};
